<template>
    <player-container v-if="playItem" :play-item="playItem" :play-item-type="playItemType" />
</template>

<script setup lang="ts">
    import { type PlayItem, PlayItemType} from "@ca.vmedia.tv/domains";
    import {linkItems} from "@/components/Header/types";
    import { useRouter } from 'vue-router';
    import { computed, onBeforeMount } from 'vue';
    import { storeToRefs } from 'pinia';
    import { usePlayerStore } from "@/stores/Player";

    const router = useRouter();     
    const {guideConfig} = useAppConfig();
    const PlayerStoreModule = usePlayerStore();
    const {
        playProgram,
        playChannel
    } = storeToRefs(PlayerStoreModule);

    const playItem = computed((): PlayItem | null => {
        return playChannel.value ?? playProgram.value;
    });
    const playItemType = computed((): string => {
        return playChannel.value ? PlayItemType.Channel : PlayItemType.Program;
    });

    const refreshPageFromGuide = () => {
        // TODO: temporary solution for Healt-Hub. It is required to pass parameters for the player via GET parameters. This will save the data after page reload.
        const featureRedirectToGuidefromPlayerEnabled = guideConfig.featureRedirectToGuidefromPlayerEnabled;
        if (playItem.value === null && featureRedirectToGuidefromPlayerEnabled) {
            void router.push(`${linkItems.guide.routerPath}`);
        }
    };

    onBeforeMount(() => {
        refreshPageFromGuide();
    });

</script>